import React from 'react'
import { withRouter } from 'react-router';
import Sidebar from '../components/layout/sidebar/Sidebar';
import Dashboard from '../components/dashboard/Dashboard'

const dashboard = () => (
    <>
    <Sidebar />
    <Dashboard />
    </>
)

export default withRouter(dashboard)    